import React, { useEffect, useRef } from 'react';

// Cross-game nav (shared across all jmsgames titles): ← back to the hub,
// → a random OTHER live game pulled from the hub manifest (proxied same-origin
// by the /api/games Pages Function). Per-game config = the two consts below.
const CURRENT_SLUG = 'drugbiz';
const HUB_URL = 'https://jmsgames.com';

function GameNav() {
  const gamesRef = useRef(null);

  function loadGames() {
    if (gamesRef.current) return Promise.resolve(gamesRef.current);
    return fetch('/api/games', { cache: 'no-cache' })
      .then((r) => (r.ok ? r.json() : { games: [] }))
      .then((d) => (gamesRef.current = (d && d.games) || []))
      .catch(() => []);
  }

  useEffect(() => {
    loadGames(); // warm the cache so the → arrow is instant
  }, []);

  function nextGame() {
    loadGames().then((games) => {
      const others = games.filter(
        (g) => g && g.status === 'live' && g.url && g.slug !== CURRENT_SLUG
      );
      window.location.href = others.length
        ? others[Math.floor(Math.random() * others.length)].url
        : HUB_URL;
    });
  }

  return (
    <div className="header-nav">
      <a className="nav-btn" href={HUB_URL} aria-label="Back to the JMS Games hub">
        <span className="nav-arw" aria-hidden="true">←</span>
        <span className="hb-text">Hub</span>
      </a>
      <button
        className="nav-btn"
        type="button"
        onClick={nextGame}
        aria-label="Jump to another game"
      >
        <span className="hb-text">Game</span>
        <span className="nav-arw" aria-hidden="true">→</span>
      </button>
    </div>
  );
}

export default GameNav;
